import { CalendarOutlined } from '@ant-design/icons';
import type { DatePickerProps } from 'antd';
import { DatePicker, Typography } from 'antd';
import type { RangePickerProps } from 'antd/es/date-picker';
import dayjs, { Dayjs } from 'dayjs';
import { memo } from 'react';

const { Title } = Typography;
const { RangePicker } = DatePicker;

interface ReportDateProps {
  isRange: boolean;
  onChange?: DatePickerProps['onChange'] | RangePickerProps['onChange'];
  value?: DatePickerProps['value'] | RangePickerProps['value'];
}

export const ReportDate = memo(({ isRange, onChange, value }: ReportDateProps) => {
  const commonProps = {
    style: { width: 256 },
    format: 'DD.MM.YYYY',
    disabledDate: (current: Dayjs) => current && current > dayjs().endOf('day'),
    suffixIcon: <CalendarOutlined style={{ color: '#022C43' }} />,
  };

  return (
    <>
      <Title level={4}>Составить отчет за</Title>
      {isRange ? (
        <RangePicker
          {...commonProps}
          onChange={onChange as RangePickerProps['onChange']}
          value={value as RangePickerProps['value']}
          placeholder={['с', 'по']}
        />
      ) : (
        <DatePicker
          {...commonProps}
          onChange={onChange as DatePickerProps['onChange']}
          value={value as DatePickerProps['value']}
          placeholder={'Выберите дату'}
        />
      )}
    </>
  );
});
